<template>
  <div>
    <div class="row mb-2" v-if="!readonly">
      <div class="col-12">
        <v-button label="Adicionar Item" icon="fa-plus" @click="handleEditItem(null)"></v-button>
      </div>
    </div>

    <div class="mainbox" v-for="(it, index) in value" :key="index">
      <div class="box">
        <div class="row align-items-center">
          <div class="col-md-4 col-12">
            <label class="lbl-list">Produto</label>
            <span class="data-list">{{ it.dscitem || 'Produto ' + it.coditem }}</span>
          </div>
          <div class="col-md-2 col-4">
            <label class="lbl-list">Qtd</label>
            <span class="data-list">{{ it.quantidade }} {{ it.unidade }}</span>
          </div>
          <div class="col-md-2 col-4">
            <label class="lbl-list">Preço</label>
            <span class="data-list">{{ it.preco | formatValue(2) }}</span>
          </div>
          <div class="col-md-2 col-4 text-right">
            <label class="lbl-list">Total</label>
            <span class="data-list">R$ {{ it.total | formatValue(2, true) }}</span>
          </div>
          <div class="col-md-2 col-12 text-right" v-if="!readonly">
            <bar-grid :options="{barDefault: true, btnEdit: true, btnDelete: true}" 
              @edit="handleEditItem(index)" 
              @delete="handleRemoveItem(index)" />
          </div>
        </div>
      </div>
    </div>

    <compra-item 
      v-if="showModal" 
      :value="selectedItem" 
      :metadata="metadata"
      @closeform="showModal = false" 
      @save="saveItem" 
    />
  </div>
</template>

<script>
import compraItem from './compra-item.vue'
import { formatValue } from '../shared/utils'

export default {
  components: { compraItem },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    readonly: Boolean,
    metadata: Object
  },
  data() {
    return {
      showModal: false,
      selectedIndex: null,
      selectedItem: {}
    }
  },
  methods: {
    handleEditItem(index) {
      this.selectedIndex = index
      this.selectedItem = index !== null ? { ...this.value[index] } : { quantidade: 1, preco: 0, total: 0 }
      this.showModal = true
    },
    saveItem(item) {
      let newValue = [...(this.value || [])]
      if (this.selectedIndex !== null) {
        newValue[this.selectedIndex] = item
      } else {
        newValue.push(item)
      }
      this.$emit('input', newValue)
      this.$emit('change')
      this.showModal = false
    },
    handleRemoveItem(index) {
      let newValue = [...(this.value || [])]
      newValue.splice(index, 1)
      this.$emit('input', newValue)
      this.$emit('change')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/forms/compra-itens.vue